import { Translation } from 'react-i18next';

/**
 * Types
 */
import type { TreeDataNode } from 'antd';

export type Permission = TreeDataNode & {
    access?: boolean;
    children?: Permission[];
};

export const permissions: Permission[] = [
    {
        children: [
            {
                access: true,
                children: [
                    {
                        access: true,
                        key: 'Attachments_Attachments_Details',
                        title: <Translation>{(t) => t('roles:Attachments_Attachments_Details')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Attachments_Attachments_Create',
                        title: <Translation>{(t) => t('roles:Attachments_Attachments_Create')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Attachments_Attachments_Edit',
                        title: <Translation>{(t) => t('roles:Attachments_Attachments_Edit')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Attachments_Attachments_Delete',
                        title: <Translation>{(t) => t('roles:Attachments_Attachments_Delete')}</Translation>,
                    },
                ],
                key: 'Attachments_Attachments',
                title: <Translation>{(t) => t('roles:Attachments_Attachments')}</Translation>,
            },
        ],
        key: 'Attachments',
        title: <Translation>{(t) => t('roles:Attachments')}</Translation>,
    },
    {
        children: [
            {
                access: true,
                children: [
                    {
                        access: true,
                        key: 'Wallpapers_Categories_Details',
                        title: <Translation>{(t) => t('roles:Wallpapers_Categories_Details')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Wallpapers_Categories_Create',
                        title: <Translation>{(t) => t('roles:Wallpapers_Categories_Create')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Wallpapers_Categories_Edit',
                        title: <Translation>{(t) => t('roles:Wallpapers_Categories_Edit')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Wallpapers_Categories_Delete',
                        title: <Translation>{(t) => t('roles:Wallpapers_Categories_Delete')}</Translation>,
                    },
                ],
                key: 'Wallpapers_Categories',
                title: <Translation>{(t) => t('roles:Wallpapers_Categories')}</Translation>,
            },
            {
                access: true,
                children: [
                    {
                        access: true,
                        key: 'Wallpapers_Posts_Create',
                        title: <Translation>{(t) => t('roles:Wallpapers_Posts_Create')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Wallpapers_Posts_Edit',
                        title: <Translation>{(t) => t('roles:Wallpapers_Posts_Edit')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'Wallpapers_Posts_Delete',
                        title: <Translation>{(t) => t('roles:Wallpapers_Posts_Delete')}</Translation>,
                    },
                ],
                key: 'Wallpapers_Posts',
                title: <Translation>{(t) => t('roles:Wallpapers_Posts')}</Translation>,
            },
        ],
        key: 'Wallpapers',
        title: <Translation>{(t) => t('roles:Wallpapers')}</Translation>,
    },
    {
        children: [
            {
                access: true,
                children: [
                    {
                        access: true,
                        key: 'System-Management_Users_Create',
                        title: <Translation>{(t) => t('create')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'System-Management_Users_Update',
                        title: <Translation>{(t) => t('update')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'System-Management_Users_Delete',
                        title: <Translation>{(t) => t('delete')}</Translation>,
                    },
                ],
                key: 'System-Management_Users',
                title: <Translation>{(t) => t('roles:System-Management_Users')}</Translation>,
            },
            {
                access: true,
                children: [
                    {
                        access: true,
                        key: 'System-Management_Roles_Create',
                        title: <Translation>{(t) => t('create')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'System-Management_Roles_Update',
                        title: <Translation>{(t) => t('update')}</Translation>,
                    },
                    {
                        access: true,
                        key: 'System-Management_Roles_Delete',
                        title: <Translation>{(t) => t('delete')}</Translation>,
                    },
                ],
                key: 'System-Management_Roles',
                title: <Translation>{(t) => t('roles:System-Management_Roles')}</Translation>,
            },
        ],
        key: 'System-Management',
        title: <Translation>{(t) => t('roles:System-Management')}</Translation>,
    },
];
